module.exports = __webpack_public_path__ + "img/icon_3_8.6cbddb1a.png";